import { Icon } from "@iconify/react";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Checkbox } from "@mui/material";
import "./Checkout.css";
import { pink } from "@mui/material/colors";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Footer from "../small/Footer";

function Checkout() {
  const coupen = "test";
  const [solprice, setSolprice] = useState("500");
  const [usdprice, setUsdprice] = useState("116.97");
  // UseState---Select Wallet------
  const [selectwallet, setShowSlctWallet] = useState(false);
  const SWhandleClose = () => setShowSlctWallet(false);
  const SWhandleShow = () => setShowSlctWallet(true);
  // UseState---slp Wallet------

  const [slpwallet, setShowSlpWallet] = useState(false);
  const handleClose = () => setShowSlpWallet(false);
  const handleShow = () => setShowSlpWallet(true);

  // UseState---Card Info------

  const [cardWallet, setShowCardWallet] = useState(false);
  const cardhandleClose = () => setShowCardWallet(false);
  const cardhandleShow = () => setShowCardWallet(true);

  // UseState---Add Address------

  const [address, setShowAddress] = useState(false);
  const addressClose = () => setShowAddress(false);
  const showAddress = () => setShowAddress(true);

  // UseState---Add Address------

  const [invoice, setShowInvoice] = useState(false);
  const closeInvoice = () => setShowInvoice(false);
  const showInvoice = () => setShowInvoice(true);

  const [coupenCode, setCoupenCode] = useState("");

  const handleCoupon = (e) => {
    setCoupenCode(e.target.value);
  };
  var tempamount;
  var tempamount2;
  const handleCheckCoupon = () => {
    const statuss = document.getElementById("statuspromocode");
    const actualprices = document.getElementById("actual-price");
    const discountsec = document.getElementById("discount-sec");
    const actualusd = document.getElementById("actual-usd");

    if (coupenCode == coupen) {
      statuss.innerHTML = "Promo code accepted 10% discount is given";

      tempamount = solprice / 10;
      tempamount = solprice - tempamount;
      //10 % of sol price percentage
      setSolprice(tempamount);

      tempamount2 = usdprice / 10;
      tempamount2 = usdprice - tempamount2;
      setUsdprice(tempamount2);
      statuss.style.visibility = "visible";
      statuss.style.background = "green";
      actualprices.style.textDecoration = "line-through";
      actualusd.style.textDecoration = "line-through";
      discountsec.style.display = "flex";
    } else {
      statuss.innerHTML = "Promo code is not valid";

      statuss.style.visibility = "visible";
      statuss.style.background = "red";
    }
  };

  return (
    <div>
      <div className="whole-main">
        <section className="checkout">
          <div className="container">
            <div className="row pdt414">
              <div className="col-sm-12">
                <div id="statuspromocode">tesst</div>
              </div>
              <div className="col-lg-7 col-12 checkout-left">
                <div className="ship-address">
                  <p>Shiping Address</p>
                  <p onClick={showAddress}>+ Add New Address</p>
                </div>

                <div className="ship-address">
                  <p>Payment Method</p>
                  <p onClick={setShowSlpWallet}>Select Payment Method</p>
                </div>

                <div className="checkout-product">
                  <div className="checkout-store-name">
                    <img src="\image\check-stor-logo.svg" alt="" />
                    <h1>Moon Rabbit Store</h1>
                  </div>

                  <div className="checkout-product-img d-flex my-3">
                    <img src="\image\item1.png" alt="" />
                    <div className="checkout-product-detail ms-3">
                      <p className="detail">
                        New Rocket Bunny Men’s Orange Color By Moon Rabbits
                        Round Neck T Shirt
                      </p>
                      <p className="detailc mt-1">Moon Rabbits (USA)</p>

                      <div className="cost-currency mt-5">
                        <p>
                          SOL : <span>500</span> &nbsp;-
                        </p>
                        <p>
                          &nbsp;<span>USD 2.41</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="ship-ct">
                    <p className="shipping-charges mt-2">Shipping USD 5.26</p>
                    <p className="delivery-time mt-2">
                      Estimated Delivery Time: 30-40 Days
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-5 col-12 checkout-right">
                <div className="checkout-right-head">
                  <div className="summary-top mt-3">
                    <h4 className="mt-4">Summary</h4>

                    <div className="ti-cost mt-4">
                      <p>Total Item Cost</p>
                      <div className="cost-currency">
                        <p>SOL : 500&nbsp;-</p>
                        <p>&nbsp;USD 2.41</p>
                      </div>
                    </div>

                    <div className="ti-cost mt-4">
                      <p>Promo Code</p>
                      <div className="d-flex align-items-center">
                        <input
                          className="coupen-input"
                          type="text"
                          placeholder="Enter code here"
                          onChange={(e) => handleCoupon(e)}
                        />
                        <button className="app-btn" onClick={handleCheckCoupon}>
                          Apply
                        </button>
                        <Icon
                          icon="akar-icons:chevron-down"
                          color="white"
                          width="12"
                          height="12"
                        />
                      </div>
                    </div>

                    <div className="ti-cost mt-4">
                      <p>Total Shipping</p>
                      <div className="cost-currency">
                        <p>SOL : 500&nbsp;-</p>
                        <p>&nbsp;USD 2.41</p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="summary-center my-4">
                    <div className="ti-cost my-4">
                      <p className="heading">Total Item Cost</p>

                      <div className=" d-flex flex-column ">
                        <div className="total-cost d-flex ">
                          <p className="cost-currency"> SOL </p>
                          <p id="actual-price" className="cost">
                            500
                          </p>
                        </div>
                        <p id="actual-usd" className="usd-cost mt-2">
                          (USD 116)
                        </p>
                      </div>
                    </div>
                    <div id="discount-sec" className="ti-cost my-4">
                      <p className="heading">Discounted Item Cost</p>

                      <div className=" d-flex flex-column ">
                        <div className="total-cost d-flex ">
                          <p className="cost-currency"> SOL </p>
                          <p className="cost">{solprice}</p>
                        </div>
                        <p className="usd-cost mt-2">(USD {usdprice})</p>
                      </div>
                    </div>
                    <div className="btn-order my-4">
                      <button onClick={showInvoice}>Place order</button>
                    </div>
                    <div className="terms">
                      <p>
                        Upon clicking ‘ Place Order’ , I confirm I have read and
                        acknowledged <span>all terms and policies.</span>
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="summary-bottom mt-4 mb-3">
                    <div className="meta-logo">
                      <img src="\image\meta-logo.svg" alt="" />
                      <p className="mt-2">
                        Metamuze keeps your information and payment safe
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>

      {/* Invoice Modal */}
      <div>
        <Modal
          show={invoice}
          onHide={closeInvoice}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="PaymentMenthodModal"
        >
          <Modal.Body className="invoiceBody">
            <div className="meta-logo">
              <img src="\image\meta-logo.svg" alt="" />
            </div>

            <div className="invoice-heading mt">
              <p>Invoice</p>
            </div>
            <div className="row top-invoice mt">
              <div className="col-md-6 ">
                <div className="invoice-subheading ">
                  <p>Store</p>
                </div>
                <p className="name">Moon Rabbits</p>
                <p className="address">www.moonrabbits.wtf</p>
              </div>
              <div className="col-md-6 top-invoice-right">
                <div className="invoice-subheading">
                  <p>Buyer</p>
                </div>
                <p className="name">Moon Rabbits</p>
                <p className="address">New York, Street 3 House # N-90</p>
                <p className="address"> New York</p>
                <p className="address">+70 5515858852</p>
              </div>
              <div className="brb">
                <hr />
              </div>
            </div>

            {/* Order Details */}
            <div className="invoice-heading ">
              <p>Order Detail</p>
            </div>

            <div className="row top-invoice mt">
              <div className="col-md-6">
                <div className="invoice-subheading ">
                  <p>Article</p>
                </div>

                <p className="address">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget
                  sit integer molestie auctor turpis sem. Amet, enim proin risus
                  dui. Commodo commodo ridiculus faucibus varius enim malesuada.
                </p>
              </div>
              <div className="col-md-6 top-invoice-right ">
                <div className="invoice-detail d-flex justify-content-between">
                  <div>
                    <div className="invoice-subheading">
                      <p>Amount</p>
                    </div>

                    <p className="address">1 Piece</p>
                  </div>

                  <div>
                    <div className="invoice-subheading">
                      <p>Price</p>
                    </div>

                    <p className="address">4.5 USD</p>
                  </div>

                  <div>
                    <div className="invoice-subheading">
                      <p>Total</p>
                    </div>

                    <p className="address">5.00 USD</p>
                  </div>
                </div>
              </div>
              <div className="brb">
                <hr />
              </div>
            </div>

            {/*  Total Bill Details */}
            <div className="row top-invoice ">
              <div className="col-md-6"></div>
              <div className="col-md-6 top-invoice-right ">
                <div className="invoice-total-bill d-flex justify-content-between">
                  <div>
                    <p className="address">Shipping</p>
                    <p className="address">Tax / VAT</p>
                    <p className="tbill">Total</p>
                  </div>
                  <div>
                    <p className="address">0 USD</p>
                    <p className="address">0 USD</p>
                    <p className="tbill">5 USD</p>
                  </div>
                </div>
              </div>
              <div className="brb">
                <hr />
              </div>
            </div>

            {/* Barcode */}

            <div className="row top-invoice mt">
              <div className="col-md-6">
                <div className="invoice-subheading ">
                  <p>Logistics</p>
                </div>
                <div>
                  <p className="address">
                    Shipping Company : <span>Metamuze</span>
                  </p>
                  <p className="address">
                    Tracking ID : <span>9090J99JFFWYUIB</span>
                  </p>
                </div>
              </div>
              <div className="col-md-6 top-invoice-right d-flex justify-content-center">
                <Icon
                  icon="icomoon-free:barcode"
                  color="white"
                  width="32"
                  height="32"
                />
              </div>
            </div>
            <div className="print">
              <button>
                <Icon icon="el:print" color="#181818" width="24" height="24" />{" "}
                Print
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      {/* -----------add Address Modal */}

      <Modal
        show={address}
        onHide={addressClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="PaymentMenthodModal addressModal"
      >
        <Modal.Header className="modalhead ">
          <div></div>
          <div className="modal-heading text-center">
            <h1>Add Address</h1>
          </div>
          <div></div>
        </Modal.Header>

        <Modal.Body className="modalBody">
          <div className="addresshead">
            <h3>Country/Region</h3>
          </div>
          <div className="row mt">
            <div className="col-md-4">
              <div className="country">
                <p>USA</p>
              </div>
            </div>
          </div>

          <div className="row mt pInfo">
            <div className="addresshead">
              <h3>Personal Information</h3>
            </div>
            <div className="col-md-6 mt ">
              <div className="country">
                <input type="text" placeholder="Contact Name *" />
              </div>
            </div>
            <div className="col-md-6 mt">
              <div className="country p-phone d-flex">
                <div>
                  <input type="text" placeholder="+ 91" className="pcode" />
                </div>
                <input type="text" placeholder="Mobile Number *" />
              </div>
            </div>
          </div>

          <p className="lbl mt-2">Please enter a Contact Name</p>

          <div className="row mt pInfo">
            <div className="addresshead">
              <h3>Address</h3>
            </div>
            <div className="col-md-6 mt ">
              <div className="country">
                <input
                  type="text"
                  placeholder="Street, house/apartment/unit *"
                />
              </div>
            </div>
            <div className="col-md-6 mt">
              <div className="country d-flex">
                <input type="text" placeholder="Apt,Suite,Unit,etc." />
              </div>
            </div>

            <div className="col-md-4 mt">
              <div className="country d-flex">
                <input type="text" placeholder="New York *" />
              </div>
            </div>
            <div className="col-md-4 mt">
              <div className="country d-flex">
                <input type="text" placeholder="3 mle bay" />
              </div>
            </div>
            <div className="col-md-4 mt">
              <div className="country d-flex">
                <input type="text" placeholder="Zipcode *" />
              </div>
            </div>
          </div>
          <div className="saveWallet mt">
            <Checkbox
              defaultChecked
              sx={{
                color: pink[600],
                "&.Mui-checked": {
                  color: pink[600],
                },
              }}
            />
            <p className="ml5">Save Wallet details</p>
          </div>

          <div className="btns mb-3">
            <button className="btndark btnc">Confirm</button>
            <button className="btnlight btnc" onClick={addressClose}>
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* -------------Select Payment Method Modal  */}

      <Modal
        show={selectwallet}
        onHide={SWhandleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="selectPaymentMethod"
      >
        <Modal.Header className="modalhead">
          <div></div>
          <div className="modal-heading">
            <h1>Payment Methods</h1>
          </div>
          <div>
            <Icon
              icon="ic:baseline-cancel"
              color="#f84a4a"
              width="32"
              height="32"
              onClick={SWhandleClose}
              className="baseline-cancel"
            />
          </div>
        </Modal.Header>

        <Modal.Body className="modalBody">
          <FormControl className="w-100">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <div className="slpwallet">
                <FormControlLabel
                  control={
                    <Radio
                      sx={{
                        color: pink[50],
                        "&.Mui-checked": {
                          color: pink[50],
                        },
                      }}
                    />
                  }
                  value="SLP Token"
                  onClick={handleShow}
                />
                <p>SOL Token</p>
              </div>
              {/* <div className="cardWallet d-flex align-items-center">
                <FormControlLabel
                  control={
                    <Radio
                      sx={{
                        color: pink[50],
                        "&.Mui-checked": {
                          color: pink[50],
                        },
                      }}
                    />
                  }
                  value="card "
                  onClick={cardhandleShow}
                />
                <div className="d-flex align-items-center">
                  <Icon
                    icon="bi:credit-card"
                    color="#dfc500"
                    width="24"
                    height="24"
                  />
                  <p className="mx-2">Credit/Debit Card</p>
                </div>
              </div> */}
            </RadioGroup>
          </FormControl>
          <p className="secureg">100% secure payment</p>
        </Modal.Body>
      </Modal>

      {/* -------------Card Info Modal Start */}

      <Modal
        show={cardWallet}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="PaymentMenthodModal"
      >
        <Modal.Header className="modalhead">
          <div></div>
          <div className="modal-heading">
            <h1>Card Info</h1>
          </div>
          <div>
            <Icon
              icon="ic:baseline-cancel"
              color="#f84a4a"
              width="32"
              height="32"
              onClick={cardhandleClose}
              className="baseline-cancel"
            />
          </div>
        </Modal.Header>

        <Modal.Body className="modalBody">
          <div className="slp-token">
            <span>
              <Icon
                icon="bi:credit-card"
                color="#dfc500"
                width="18"
                height="18"
              />
            </span>
            <p>Credit/Debit Card</p>
          </div>

          <div className="row mt-3">
            <div className="col-md-6 col-12">
              <div className="card-nmbr">
                <input type="number" name="" id="" placeholder="Card Number" />
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="card-nmbr">
                <input
                  type="text"
                  name=""
                  id=""
                  placeholder="Cardholder Name"
                />
              </div>
            </div>

            <div className="col-md-6 col-12 my-3 d-flex justify-content-between align-items-center exp-my">
              <select name="drinks" required>
                <option value="" disabled selected hidden>
                  MM
                </option>
                <option value="coffee">Coffee</option>
                <option value="tea">Tea</option>
                <option value="milk">Milk</option>
              </select>
              <p>/</p>
              <select name="drinks" required>
                <option value="" disabled selected hidden>
                  YY
                </option>
                <option value="coffee">Coffee</option>
                <option value="tea">Tea</option>
                <option value="milk">Milk</option>
              </select>
            </div>
            <div className="col-md-6 col-12 my-3">
              <div className="card-cvv card-nmbr  d-flex align-items-center px-2">
                <input type="number" name="" id="" placeholder="CVV" />
                <Icon
                  icon="codicon:info"
                  color="#FFFFFF"
                  width="16"
                  height="16"
                  onClick={handleClose}
                  className="baseline-cancel"
                />
              </div>
            </div>
          </div>

          <div className="bodybottom">
            <div className="saveWallet">
              <Checkbox
                defaultChecked
                sx={{
                  color: pink[600],
                  "&.Mui-checked": {
                    color: pink[600],
                  },
                }}
              />
              <p className="ml5">Save Wallet details</p>
            </div>
            <div className="walletinfo">
              <Icon
                icon="codicon:info"
                color="#A9A9A9"
                width="24"
                height="24"
              />
              <p className="ml5">
                Your order will be processed in USD OR SOL token
              </p>
            </div>
          </div>
          <hr />
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <div className="modalfooter d-flex align-items-center">
            <div className="payment-safe d-flex align-items-center">
              <Icon
                icon="icon-park-outline:protect"
                color="#A9A9A9"
                width="24"
                height="24"
              />
              <p className="ml5">
                Your order will be processed in USD OR SOL token
              </p>
            </div>
            <div className="saveconti">
              <button>Save & Confirm</button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* -------------SLP Payment Method Modal Start */}

      <Modal
        show={slpwallet}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="PaymentMenthodModal"
      >
        <Modal.Header className="modalhead">
          <div></div>
          <div className="modal-heading">
            <h1>Wallet Info</h1>
          </div>
          <div>
            <Icon
              icon="ic:baseline-cancel"
              color="#f84a4a"
              width="32"
              height="32"
              onClick={handleClose}
              className="baseline-cancel"
            />
          </div>
        </Modal.Header>

        <Modal.Body className="modalBody">
          <div className="slp-token">
            <span>
              <Icon
                icon="bi:credit-card"
                color="#dfc500"
                width="18"
                height="18"
              />
            </span>
            <p>SOL Token</p>
          </div>
          <div className="slp-wallet">
            <button className="connect-btn">Connect Wallet</button>
          </div>
          <div className="bodybottom">
            <div className="saveWallet">
              <Checkbox
                defaultChecked
                sx={{
                  color: pink[600],
                  "&.Mui-checked": {
                    color: pink[600],
                  },
                }}
              />
              <p className="ml5">Save Wallet details</p>
            </div>
            <div className="walletinfo">
              <Icon
                icon="codicon:info"
                color="#A9A9A9"
                width="24"
                height="24"
              />
              <p className="ml5">
                Your order will be processed in USD OR SOL token
              </p>
            </div>
          </div>
          <hr />
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <div className="modalfooter d-flex align-items-center">
            <div className="payment-safe d-flex align-items-center">
              <Icon
                icon="icon-park-outline:protect"
                color="#A9A9A9"
                width="24"
                height="24"
              />
              <p className="ml5">
                Your order will be processed in USD OR SOL token
              </p>
            </div>
            <div className="saveconti">
              <button>Save & Confirm</button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Checkout;
